import React, { useState, useCallback, useEffect } from 'react'
import { connect } from 'react-redux'
import { Translate } from 'react-localize-redux'
import { Grid, TablePagination } from '@material-ui/core'
import { DrillCard, LoadingSpinner, NotFound } from 'components'
import PropTypes from 'prop-types'
import {
  fetchFavouriteDrills,
  updateFavoriteDrill,
} from 'containers/ActivitiesContainer/api'
import { useStyles } from 'containers/ActivitiesContainer/styles'

const DrillsCarousel = ({ teamUuid }) => {
  const classes = useStyles()

  const [drills, setDrills] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(12)
  const [page, setPage] = useState(0)
  const [meta, setMeta] = useState({})
  const [loading, setLoading] = useState(true)

  const loadDrills = useCallback(() => {
    setLoading(true)
    fetchFavouriteDrills(teamUuid, {
      page: page + 1,
      per_page: rowsPerPage,
    })
      .then((response) => {
        setDrills(response.data)
        setMeta(response.meta)
      })
      .catch((err) => {
        console.error('Failed to fetch favourite drills', err)
        setDrills([])
        setMeta({})
      })
      .finally(() => {
        setLoading(false)
      })
  }, [teamUuid, page, rowsPerPage])

  useEffect(() => {
    loadDrills()
  }, [loadDrills])

  const handleFavoriteToggle = (article) => {
    updateFavoriteDrill(article.uuid, !article.favorite)
      .then(() => {
        loadDrills(page, rowsPerPage)
      })
      .catch((error) => {
        console.error('Error toggling favorite status:', error)
      })
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  return (
    <>
      <Grid item xs={12}>
        <TablePagination
          labelRowsPerPage={<Translate id="drills.rows-perpage" />}
          component="div"
          count={meta?.total ?? 0}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          className={classes.pagination}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[12, 24, 36]}
          SelectProps={{
            MenuProps: {
              PaperProps: { elevation: 0 },
            },
          }}
        />
      </Grid>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <Grid container spacing={3}>
          {drills.length > 0 ? (
            drills.map((drill) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={drill.uuid}>
                <DrillCard
                  withPhaseMenu={false}
                  showAddToTrainingButton={false}
                  showDrillActions={false}
                  drill={drill}
                  onFavoriteToggle={() => handleFavoriteToggle(drill)}
                  onPhaseSelect={() => {}}
                  onDuplicate={() => {}}
                />
              </Grid>
            ))
          ) : (
            <NotFound />
          )}
        </Grid>
      )}
    </>
  )
}

DrillsCarousel.propTypes = {
  teamUuid: PropTypes.string.isRequired,
}

export default connect(({ team }) => ({
  teamUuid: team.uuid,
}))(DrillsCarousel)
